import { Box, Typography } from "@mui/material";
import PageLayout from '../../components/PageLayout.tsx';

const steps = [
  {
    title: "Überblick",
    description: `Der qdTest-Konfigurator führt durch den gesamten Konfigurationsprozess für qdTest-Systeme. Er ermöglicht die Definition mechanischer, elektronischer und testprozeduraler Parameter und unterstützt Sie bis hin zur Angebotsanfrage und Preisberechnung.`,
  },
  {
    title: "Export / Import",
    description: `Die gesamte Konfiguration kann exportiert und zu einem späteren Zeitpunkt wieder importiert werden. Die beiden entsprechenden Buttons befinden sich oben rechts im Header.`,
  },
  {
    title: "Integration Elektronik-CAD",
    description: `Im Bereich „Mechanik” können die Testpunkte direkt aus dem Testpunkt-Report des Elektronik-CAD-Programms als CSV importiert werden. Im unteren Bereich werden die Positionen der Testpunkte und DUTs angezeigt. Direkt darunter befindet sich ein Download-Button, mit dem sich die DXF-Datei herunterladen lässt, um die Positionen direkt im Elektronik-CAD-Programm zu verifizieren.`,
  },
  {
    title: "Prüfabläufe auf Testsystem spielen",
    description: `Im Bereich „Prüfabläufe” finden Sie den Button „Download Prüfabläufe”. Entpacken Sie anschließend alle Dateien und kopieren Sie diese auf den USB-Stick des qdTest-Systems. Stecken Sie den Stick wieder in das qdTest-System und starten Sie es neu. Nun sind die Prüfabläufe vorhanden.`,
  },
  {
    title: "Angebot anfragen",
    description: `Senden Sie uns Ihre Anfrage direkt auf diesem System heraus. Wir senden Ihnen zeitnah ein Angebot zu bzw. Kontaktieren Sie bei Rückfragen.`,
  },
  {
    title: "Support",
    description: `Für Fragen und Anregungen stehen wir Ihnen gerne unter der Telefonnummer +49(0) 7807 / 890 80 10 bzw. unter der E-Mail-Adresse vertrieb@querdenker-engineering.de zur Verfügung.`,
  },
];

const HomePage = () => {

  return (
    <PageLayout
      title="HowTo"
      nextText="Konfiguration starten"
      nextTarget="/project"
    >
      {steps.map((step, index) => (
        <Box
          key={index}
          sx={{ display: "flex", gap: 2, alignItems: "flex-start", mb: 4 }}
        >
          <Typography variant="h4" sx={{ minWidth: "40px" }}>
            {index + 1}.
          </Typography>
          <Box>
            <Typography variant="h6">{step.title}</Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              whiteSpace="pre-line"
            >
              {step.description}
            </Typography>
          </Box>
        </Box>
      ))}
    </PageLayout>
  );
};

export default HomePage;
